export const projects = [
  {
    title: "Dot and Key Clone",
    description:
      "Dot & Key is an Indian cosmetics brand that offers premium skin care products, including serums,face masks, toners, and cleansers",
    stack:"JavaScript | HTML | CSS | Bootstrap" ,
    image: "./dotandkey.png",
    link: "https://dotandkeyclone.netlify.app/index.html",
    github:"https://github.com/Hashal890/dot-key-clone",
  },
  {
    title: "Kickstarter Clone",
    description:
      "Kickstarter is an American public benefit corporation that maintains a global crowdfunding platform focused on creativity.",
    image: "./kickstarter.png",
    stack:"JavaScript | HTML | CSS | React | ChakraUI" ,
    link: "https://kickstarterclonebygaurav.netlify.app/",
    github:"https://github.com/GauravMishra28/dead-test-3122"
  },
  {
    title: "KindMeal Clone",
    description:
      "KindMeal is Malaysia's leading meat-free lifestyle platform, indulging with delicious discounted vegetarian meals in cozy environments.",
    stack:"JavaScript | HTML | CSS | Bootstrap" ,
    image: "./kindmeal.png",
    link: "https://keen-pasca-121c61.netlify.app/index.html",
    github:"https://github.com/Aman103767/TEAM-ONE-PIECE",
  },
 
  {
    title: "Star Wars Character Search",
    description:
      "Star Wars is an epic space opera multimedia franchise which began with the eponymous 1977 film and quickly became a worldwide pop-culture phenomenon.",
    image: "./starwars.png",
    stack:"JavaScript | HTML | CSS | SWAPI" ,
    link: "https://polite-froyo-0e8b89.netlify.app/",
    github:"https://github.com/GauravMishra28/Mini-Projects/tree/main/star%20wars"
  },
  // {
  //   title: "Youtube Clone",
  //   description:
  //     "YouTube is a global online video sharing and social media platform headquartered in California.",
  //   image: "./project-4.gif",
  //   stack:"JavaScript | HTML | CSS" ,
  //   link: "https://app.netlify.com/sites/dancing-sorbet-4f40a9/overview",
  // },
];



export const skills = [
 { name:"HTML", img:"https://img.icons8.com/color/48/000000/html-5--v1.png"},
 {name:"CSS", img:"https://img.icons8.com/color/48/000000/css3.png"},
 { name:"JavaScript", img:"https://img.icons8.com/fluency/48/000000/javascript.png"},
 { name:"React", img:"https://img.icons8.com/plasticine/200/000000/react.png"},
 {name:"Redux", img:"https://img.icons8.com/color/48/000000/redux.png"},
 {name:"TypeScript", img:"https://img.icons8.com/color/48/000000/typescript.png"},
 {name:"MongoDB", img:"https://img.icons8.com/color/48/000000/mongodb.png"},
 {name:"NodeJS", img:"https://img.icons8.com/color/48/000000/nodejs.png"},
 {name:"Express JS",img:"https://img.icons8.com/nolan/64/express-js.png"},
 {name:"Git",img:"https://img.icons8.com/color/48/000000/git.png"},
 {name:"npm",img:"https://img.icons8.com/color/48/000000/npm.png"},
 {name:"Github",img:"https://img.icons8.com/glyph-neue/64/000000/github.png"},


];





// WEBPACK FOOTER //
// ./src/data.js